import { createPayWithCardFormContainer } from './container'
import { PayWithCardForm as PayWithCardFormUI } from './ui/pay-with-card-form'

export const PayWithCardForm = createPayWithCardFormContainer(PayWithCardFormUI)
